import React from 'react';
import { X } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const ConfirmDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDangerous = false
}) => {
  const { theme } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div 
        className="w-full max-w-md rounded-lg p-6"
        style={{ backgroundColor: theme.background }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold" style={{ color: theme.text }}>
            {title}
          </h3>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-secondary transition-colors"
            style={{ color: theme.text }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Message */}
        <p className="mb-6" style={{ color: theme.text }}>
          {message}
        </p>

        {/* Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg transition-colors"
            style={{ 
              backgroundColor: theme.secondary,
              color: theme.text
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="px-4 py-2 rounded-lg text-white transition-colors"
            style={{ 
              backgroundColor: isDangerous ? '#ef4444' : theme.primary,
              color: '#ffffff'
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog; 